import { render, staticRenderFns } from "./Routing.vue?vue&type=template&id=965a32c0&scoped=true"
import script from "./Routing.vue?vue&type=script&lang=js"
export * from "./Routing.vue?vue&type=script&lang=js"
import style0 from "./Routing.vue?vue&type=style&index=0&id=965a32c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965a32c0",
  null
  
)

export default component.exports